import React from "react";

export const QuestionLinks = (props) => {
    return (
        <>
            <div className={props.className}>
                <div className="sb-question-links">
                    <ul >
                        {props.children}
                    </ul>
                </div>
            </div>
        </>
    )
}